import React, { useEffect, useMemo, useState,useRef, } from "react";
import useStyles from "./style";
import { Grid, Typography } from "@mui/material";
import { Person } from "@mui/icons-material";
import moment from "moment-timezone";
import Carousel from "react-material-ui-carousel";
import { CUSTOM_CONSTANTS } from "Constants";
import {
  IconButton,
} from "@mui/material";

import {
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";



const Estimatedcarousel = ({ distance, duration, services, timezone, setTravelduration, setActiveService }) => {
  const classes = useStyles();
const [selectedIndex, setSelectedIndex] = useState(0);
const scrollerRef = useRef(null);
  // ✅ Parse distance/duration safely
  const traveldistance = useMemo(
    () => parseFloat(distance?.replace("km", "").trim()) || 0,
    [distance]
  );

  const travelduration = useMemo(() => {
    let minutes = 0;
    const parts = duration?.match(/(\d+)\s*hours?|\d+\s*mins?/g);
    if (parts) {
      for (const part of parts) {
        if (part.includes("hour")) minutes += parseInt(part) * 60;
        else if (part.includes("min")) minutes += parseInt(part);
      }
    }
    return minutes;
  }, [duration]);

  // ✅ Tell parent duration only when it changes
  useEffect(() => {
    setTravelduration(travelduration);
  }, [travelduration, setTravelduration]);

  // ✅ Build service fares only once per inputs
  const serviceFares = useMemo(() => {
    return services?.map((service) => {
      const { fareDetails, serviceName, serviceImage, serviceImageDecription, seatsAvailable, serviceDescritpion, _id, ...other } =
        service;

      const distanceprice = fareDetails.daytime.unitPrice * traveldistance;
      const timeprice = fareDetails.daytime.minutePrice * travelduration;
      const addToFarePrice = parseFloat((((distanceprice + timeprice) * fareDetails.daytime.addtofare) / 100).toFixed(2));

      const totalfare = distanceprice + timeprice + addToFarePrice + fareDetails.daytime.basePrice;

      const estimated_fare = parseFloat(totalfare.toFixed(2));

      const currentTime = moment.tz(timezone);
      const dropOffTime = currentTime.clone().add(travelduration, "minutes").format("hh:mm A");

      return {
        ...other,
        service_id: _id,
        description: serviceDescritpion,
        service_image: serviceImage,
        service_image_description: serviceImageDecription,
        seats_available: seatsAvailable,
        service_name: serviceName,
        drop_off_time: dropOffTime,
        estimated_fare,
        distance,
      };
    });
  }, [services, traveldistance, travelduration, distance, timezone]);

  // ✅ Set default active service only once
useEffect(() => {
  if (serviceFares?.length > 0) {
    setSelectedIndex(0);
    setActiveService(serviceFares[0]);
  }
}, [serviceFares, setActiveService]);;

const handleScroll = (direction) => {
  if (!scrollerRef.current) return;

  const amount = 250;

  scrollerRef.current.scrollBy({
    left: direction === "left" ? -amount : amount,
    behavior: "smooth",
  });
};

  return (
   <div className={classes.wrapper}>
  <Typography
    variant="caption"
    sx={{
      display: "block",
      marginBottom: 0.5,
      fontWeight: 600,
      color: "#333",
    }}
  >
    Available Vehicles
  </Typography>

  <div className={classes.carouselShell}>
    <IconButton
      className={classes.arrowButton}
     onClick={() => handleScroll("left")}
      size="small"
    >
      <ChevronLeft />
    </IconButton>

    <div className={classes.cardsScroller} ref={scrollerRef}>
      {serviceFares?.map((service, index) => (
        <div
          key={service.service_id}
          className={`${classes.vehicleCard} ${
            selectedIndex === index
              ? classes.vehicleCardActive
              : ""
          }`}
          onClick={() => {
            setSelectedIndex(index);
            setActiveService(service);
          }}
        >
          <div className={classes.cardImageWrap}>
            <img
              src={service.service_image}
              alt={service.service_name}
              className={classes.cardImage}
            />
          </div>

          <div className={classes.cardBody}>
            <div className={classes.cardTitle}>
              {service.service_name}
            </div>

            <div className={classes.cardMeta}>
              <Person fontSize="small" />
              <span className={classes.seats}>
                {service.seats_available}
              </span>
            </div>

            <div className={classes.cardPrice}>
              {service.estimated_fare}
              {CUSTOM_CONSTANTS.BASE_CURRENCY}
            </div>

            {/* <Typography
              variant="caption"
              sx={{
                color: "#666",
                textAlign: "center",
                mt: 1,
              }}
            >
              Drop off: {service.drop_off_time}
            </Typography> */}
          </div>
        </div>
      ))}
    </div>

    <IconButton
      className={classes.arrowButton}
      onClick={() => handleScroll("right")}
      size="small"
    >
      <ChevronRight />
    </IconButton>
  </div>
</div>
  );
};

export default Estimatedcarousel;
